import styled from "styled-components";

const TitleStyles = styled.h1`
  font-family: "Sora", sans-serif;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 32}px;
  text-align: center;
  margin: ${({ theme }) => theme.CONSTANTS.XH * 3}px 0;
  color: ${({ theme }) => theme.THEME.white};

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 10}px;
  }
`;

export default TitleStyles;
